import css_abciqw2pyk from './css/Poster.css';
import Div from './Div.js';

const css = css_abciqw2pyk;

export default class Poster extends Div
{
	constructor(parentElement)
	{
		super(parentElement);
	}

	get cssText()
	{
		return css;
	}

	set value(value)
	{
		this.element.style.backgroundImage = `url(${value})`;
	}
}